import { Link } from 'react-router-dom';
import { nextStep } from '@/mocks/essentialCourseData';
import { useTranslation } from 'react-i18next';

export default function NextStep() {
  const { t } = useTranslation();
  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="border border-accent-500/20 bg-background-50 p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          {/* Icon */}
          <div className="flex-shrink-0">
            <span className="w-14 h-14 flex items-center justify-center">
              <i className="ri-arrow-up-circle-line text-accent-500 text-3xl"></i>
            </span>
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left">
            {String(t('coursesEssential.nextStep.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-accent-600 tracking-[0.15em] mb-3 font-label">{__s}</p>))}
            <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.06em] mb-3">
              {t('coursesEssential.nextStep.title')}
            </h3>
            {String(t('coursesEssential.nextStep.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 leading-relaxed tracking-[0.03em] mb-4">{__s}</p>))}
            <p className="text-[15px] text-accent-700 font-medium tracking-[0.05em]">
              {t('coursesEssential.nextStep.discountLabel').replace('{amount}', t('coursesEssential.nextStep.discountAmount'))}
            </p>
          </div>

          {/* CTA */}
          <div className="flex-shrink-0">
            <Link
              to="/courses/advanced"
              className="btn-glow inline-block px-6 py-3 border border-accent-500/50 text-accent-600 hover:text-accent-500 hover:border-accent-400 hover:bg-accent-500/5 text-[14px] tracking-[0.08em] text-center transition-all duration-300 whitespace-nowrap"
            >
              {t('coursesEssential.nextStep.viewAdvanced')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}